import { formatHtml } from "@trumpf/ux.common-storybook";
import { ContactSliderTemplate } from "./contact-slider.templates";

export default {
    title:
        "Website/Page Templates/Search/Search Results Sliders/Contact Slider",
    render: ContactSliderTemplate.bind({}),
    tags: ["autodocs"],
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const ContactSlider = {};
